import {EventQuestion, ExpandedOrder} from "../../services/api/models/Models";
import {ColumnData} from "../../components/styledTable/useCreateColumns";
import {formatDateMST} from "../../utils/dateTImeHelper";
import {FilterableColumn} from "../../components/styledTable/styledTableHelper";

export function buildColumnData(eventQuestions: EventQuestion[]): ColumnData[] {
  const baseOrderColumns: ColumnData[] = [
    {
      id: "Order ID",
      columnHeader: "Order ID",
      accessorFn: (row) => row.id,
    },
    {
      id: "Ticket Name",
      columnHeader: "Ticket Name",
      accessorFn: (row) => row.ticketName,
    },
    {
      id: "Amount Paid",
      columnHeader: "Amount Paid",
      accessorFn: (row) => row.amountPaid,
    },
    {
      id: "Check In Status",
      columnHeader: "Check In Status",
      accessorFn: (row) => String(row.checkInStatus),
    },
    {
      id: "Order Date",
      columnHeader: "Order Date",
      accessorFn: (row) => row.createdAt,
    },
  ];

  const questionColumns: ColumnData[] = eventQuestions.map((eq) => ({
    id: eq.id.toString(),
    columnHeader: eq.question,
    accessorFn: (row) => {
      const found = row.orderAnswers?.find(
        (oa: any) => oa.eventQuestion.id === eq.id
      );
      return found?.answer;
    },
  }));

  return [...questionColumns, ...baseOrderColumns];
}

export function buildFiltrableColumns(eventQuestions: EventQuestion[]) {
  const baseFilterableColumns: FilterableColumn[] = [
    {
      columnId: "Order ID",
      columnHeader: "Order ID",
      columnType: "text",
      accessorFn: (row) => row.id,
    },
    {
      columnId: "Ticket Name",
      columnHeader: "Ticket Name",
      columnType: "text",
      accessorFn: (row) => row.ticketName,
    },
    {
      columnId: "Amount Paid",
      columnHeader: "Amount Paid",
      columnType: "text",
      accessorFn: (row) => row.amountPaid,
    },
    {
      columnId: "Check In Status",
      columnHeader: "Check In Status",
      columnType: "select",
      columnOptions: ["true", "false"],
      accessorFn: (row) => String(row.checkInStatus),
    },
    {
      columnId: "Order Date",
      columnHeader: "Order Date",
      columnType: "date",
      accessorFn: (row) => row.createdAt,
    },
  ];

  const questionFilterableColumns: FilterableColumn[] = eventQuestions.map(
    (eq) => ({
      columnId: eq.id.toString(),
      columnHeader: eq.question,
      columnType: eq.options ? "select" : "text",
      columnOptions: eq.options ?? [],
      accessorFn: (row) => {
        const found = row.orderAnswers?.find(
          (oa: any) => oa.eventQuestion.id === eq.id
        );
        return found?.answer;
      },
    })
  );

  return [...questionFilterableColumns, ...baseFilterableColumns];
}

export function getGrossSalesFromOrders(orders: ExpandedOrder[]): string {
  const grossSales = orders.reduce(
    (acc, order) => acc + Number(order.amountPaid) / 100,
    0
  );
  return grossSales.toLocaleString("en-CA");
}

export function getLatestOrderFromOrders(orders: ExpandedOrder[]): string {
  const latestOrder = formatDateMST(orders[0].createdAt);
  return latestOrder;
}
